(function () {
    angular.module('app')
        .directive('dynamicHeight', function ($window) {
            return {
                link: function (scope, element, attrs) {
                    var window_height = $window.innerHeight;

                    element.css('min-height', window_height - 150 + 'px');
                }
            }
        });
})();